import { colors } from 'src/utils/colors';
import { CartridgeInfoType, CartridgeType } from './setCartridgeType';

export const cartridges: CartridgeInfoType[] = [
	{
		type: CartridgeType.Custom,
		name: 'form.cartridges.blue.color',
		image: 'Custom.png',
		color: colors.cartridge.blue,
		description: 'form.cartridges.blue.description',
		for: 'form.cartridges.blue.for',
		attributes: [
			{ label: 'form.cartridges.labels.supply', value: 'form.cartridges.blue.supply' },
			{ label: 'form.cartridges.labels.fee', value: 'form.cartridges.blue.fee' },
			{ label: 'form.cartridges.labels.price', value: 'form.cartridges.blue.price' },
			{ label: 'form.cartridges.labels.colorText', value: 'form.cartridges.blue.colorText' },
		],
		maxSupply: 99999999999,
		number: 1,
		maxFee: 100,
	},
	{
		type: CartridgeType.Gold,
		name: 'form.cartridges.gold.color',
		color: colors.cartridge.gold,
		image: 'Golden.png',
		description: 'form.cartridges.gold.description',
		for: 'form.cartridges.gold.for',
		attributes: [
			{ label: 'form.cartridges.labels.supply', value: 'form.cartridges.gold.supply' },
			{ label: 'form.cartridges.labels.fee', value: 'form.cartridges.gold.fee' },
			{ label: 'form.cartridges.labels.price', value: 'form.cartridges.gold.price' },
			{ label: 'form.cartridges.labels.colorText', value: 'form.cartridges.gold.colorText' },
		],
		maxSupply: 133700,
		number: 2,
		maxFee: 20,
	},
	{
		type: CartridgeType.Gray,
		name: 'form.cartridges.gray.color',
		color: colors.cartridge.gray,
		image: 'Gray.png',
		for: 'form.cartridges.gray.for',
		description: 'form.cartridges.gray.description',
		attributes: [
			{ label: 'form.cartridges.labels.supply', value: 'form.cartridges.gray.supply' },
			{ label: 'form.cartridges.labels.fee', value: 'form.cartridges.gray.fee' },
			{ label: 'form.cartridges.labels.price', value: 'form.cartridges.gray.price' },
			{ label: 'form.cartridges.labels.colorText', value: 'form.cartridges.gray.colorText' },
		],
		maxSupply: 100000000000,
		number: 3,
		maxFee: 100,
	},
];
